import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Select as AntdSelect } from 'antd';
import { theme } from 'utils/style/theme';
const { Option } = AntdSelect;
/**
 * * 기본 셀렉 박스 (드롭다운)
 */

interface IOptionList {
  key?: string | number;
  value: string | number;
  text: string | number;
}
interface IProps {
  allowClear?: boolean;
  bottom?: string | boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  defaultValue?: string | string[] | number | number[];
  disabled?: boolean;
  filterOption?: boolean;
  id?: string;
  key?: string;
  mode?: 'multiple' | 'tags' | undefined;
  name?: string;
  optionList?: IOptionList[];
  onChange?: (e, d) => void;
  onSearch?: (e: any) => void;
  onInputKeyDown?: (e: any) => void;
  onKeyUp?: (e) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  title?: string;
  tokenSeparators?: Array<string>;
  value?: string | string[] | number | number[];
  width?: string | undefined;
  labelStyle?: React.CSSProperties;
  showAllOption?: boolean;
}
const Select = ({
  title,
  optionList = [],
  placeholder,
  mode,
  value,
  defaultValue,
  name,
  onChange,
  onSearch,
  style,
  disabled,
  allowClear,
  onKeyUp,
  onInputKeyDown,
  filterOption,
  tokenSeparators,
  width,
  id,
  key,
  bottom,
  noMarginBottom,
  labelStyle,
  showAllOption,
}: IProps) => {
  const options = showAllOption ? getDropdownWithAll(optionList) : optionList;
  return (
    <Container
      style={style}
      title={title}
      bottom={bottom}
      noMarginBottom={noMarginBottom}
    >
      <label style={labelStyle}>{title}</label>
      <StyledSelect
        mode={mode}
        value={value}
        defaultValue={defaultValue || showAllOption ? 'all' : undefined}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        onSearch={onSearch}
        onInputKeyDown={onInputKeyDown}
        allowClear={allowClear}
        onKeyUp={onKeyUp}
        filterOption={filterOption}
        tokenSeparators={tokenSeparators}
        width={width}
        name={name}
        id={id}
        key={key}
      >
        {options?.map((v) => (
          <Option key={v.key || v.value} value={v.value} name={name} id={id}>
            {v.text}
          </Option>
        ))}
      </StyledSelect>
    </Container>
  );
};

export default Select;

const Container = styled.div<IProps>`
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '1.2rem')};
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
  }
`;
const StyledSelect = styled(AntdSelect)<IProps>`
  background-color: #fff;
  border-radius: 0.4rem;
  /* box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 5%); */
  width: ${(props) => (props.width ? props.width : '100%')};
  &.ant-select .ant-select-selector {
    padding: 0.6rem 0.7rem;
    min-height: 2.8rem;
    border: 1px solid ${theme.colors.gray_5};
    border-radius: 0.4rem;
  }
  /* 셀렉박스 안 텍스트 */
  .ant-select-single.ant-select-show-arrow,
  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }
`;

const getDropdownWithAll = (optionList: IOptionList[]) => {
  return [
    {
      key: 'all',
      value: 'all',
      text: '전체',
    },
    ...optionList,
  ];
};
